import { CreditPackagesContent } from '../components/CampaignsCreditPackagesSection';

export const SMS_CREDIT_PACKAGES_CONTENT: CreditPackagesContent = {
  eyebrow: 'SMS billing',
  heading: 'Top up your SMS credit',
  subheading: 'Buy message bundles in advance and get better rates. Credit never expires and works across all your campaigns.',
  balance: {
    title: 'Pay-as-you-grow',
    subtitle: 'SMS messaging credit',
    description:
      'No monthly fee, no surprises. One credit pool for all your SMS campaigns. 1 credit = 1 SMS segment: long messages or special characters consume more credits.',
    availableBalanceLabel: 'Credit Balance',
    availableBalanceValue: '8,420',
    availableBalanceUnit: 'credits available',
    renewalHint: 'Auto top-up enabled',
  },
  packsEyebrow: 'Choose your pack',
  packsHeading: 'The more you buy, the less you pay',
  volumeLabel: 'credits',
  showPopularBadge: false,
  solidPopularCta: false,
  packages: [
    {
      id: 'starter',
      title: 'Starter',
      messages: '5k',
      price: '€245',
      rateLabel: '€0.049 per SMS',
      features: ['No setup cost', 'Standard delivery rate'],
      ctaLabel: 'Buy starter',
    },
    {
      id: 'growth',
      title: 'Growth',
      messages: '25k',
      price: '€1,100',
      rateLabel: '€0.044 per SMS',
      features: ['Volume discount 10%', 'Priority support'],
      ctaLabel: 'Buy growth',
      isPopular: true,
    },
    {
      id: 'business',
      title: 'Business',
      messages: '100k',
      price: '€3,900',
      rateLabel: '€0.039 per SMS',
      features: ['24/7 priority support', 'Dedicated throughput'],
      ctaLabel: 'Buy business',
    },
    {
      id: 'enterprise',
      title: 'Enterprise',
      messages: '500k',
      price: '€17,500',
      rateLabel: '€0.035 per SMS',
      features: ['Custom SLA and DPA', 'API plus webhook limits'],
      ctaLabel: 'Buy enterprise',
    },
  ],
};
